/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcRowSelectAll
 * @restrict A
 * @description
 * The wcRowSelectAll directive is responsible for selecting all rows of the datatable on a single click.
 */



angular.module('WcResponsiveTableModule').directive('wcRowSelectAll', function() {
	return {
		restrict: 'A',
		require: ['wcRowSelectAll', '^wcResponsiveTable', '^ngModel'],
		scope: {},
		controllerAs: 'rowSelectAllController',
		controller: ['$scope', '$element', function ($scope, $element) {
			var responsiveTableController = $element.parent().controller('wcResponsiveTable');
			this.viewScope = responsiveTableController.WcTableScopeService.getParentScope();

			this.selectAll = function() {
				this.viewScope.$broadcast('table.select.checkbox.all');
				this.viewScope.$broadcast('table.select.button.all');
				$scope.$apply();
			};
		}],
		link: function(scope, element, attrs, controllers) { //jshint unused:true
			var rowSelectAllController = controllers[0];
			element.on('click', function () {
				rowSelectAllController.selectAll();
			});
		}
	};
});
